import * as React from 'react';
import { Button, createStyles, Theme, Tooltip, withStyles, WithStyles } from '@material-ui/core';
import {Link} from 'react-router-dom';
const styles = (theme: Theme) => createStyles({
  containerButtonsTaiApp: {
    maxWidth: 390,
    position: 'fixed',
    bottom: 20,
    right: 25,
  },
  btnTaiApp:{
    width:120,
    height:38,
    backgroundColor:'rgb(206 206 206)',
    border: '2px solid white',
    borderRadius: 7,
    marginRight: 5,
  },
  btnLogIn:{
    width:92,
    height:38,
    backgroundColor:'rgb(206 206 206)',
    border: '2px solid white',
    borderRadius: 7,
  },
  iconsBtn:{
    width: '120%'
  },
  chuyenTrang:{
    textDecoration:'none',
    margin: '0 auto'
  },
  externalLink:{
    textDecoration:'none',
    margin: '0 auto'
  },
  textDangNhap:{
    fontSize: 16,
    fontWeight: 600,
    marginLeft: -16,
    marginTop:2
  }
})
type Props = {
} & WithStyles<typeof styles>;
type States = {
};
class ButtonsTaiAppComponent extends React.Component<Props, States> {

  private buttons = [
    {name:'Tải ứng dụng TCTTQH ios', externalLink:'https://apps.apple.com/us/app/id1500361245', src:'/images/icons/apple_download.jpg'},
    { src:'/images/icons/android_download.jpg', name:'Tải ứng dụng TCTTQH android', externalLink:'https://play.google.com/store/apps/details?id=ditagis.bp.ttqhxd'},
    {name:'Đăng nhập', path:'login', src:'/images/icons/login.jpg'}];

  render() {
  const { classes } = this.props;

    return (
      <div className={classes.containerButtonsTaiApp}>
        {

          this.buttons.map(element => {
            if (element.externalLink) {
              return <a href={element.externalLink} className={classes.externalLink} target="_blank"><Button className={classes.btnTaiApp} style={{backgroundImage:`url('${element.src}')`, backgroundSize:'105%', backgroundPosition:'center'}}></Button></a>
            }
            return <Link className={classes.chuyenTrang} to={element.path} ><Button style={{backgroundImage:`url('${element.src}')`, backgroundSize:'102%', backgroundPosition:'center'}} className={classes.btnLogIn}></Button></Link>
          })
        }
      </div>
    );
  }
}

export default withStyles(styles)(ButtonsTaiAppComponent);
